<!--  -->
<template>
  <div>
     <div class="clear"></div>
      <div class="typebox">
        <ul>
          <li><router-link  to="/courviews"><img src="/static/images_m/icon_1.jpg">
            <p>选课中心</p>
             </router-link>
          </li>
          <li><router-link  to="/mycourses"><img src="/static/images_m/icon_3.jpg">
            <p>课程中心</p>
             </router-link>
          </li>
          <li><router-link  to="/papercenter"><img src="/static/images_m/icon_2.jpg">
            <p>考试中心</p>
             </router-link>
          </li>
          <li>
            <router-link to="/liveview">
              <img src="/static/images_m/icon_4.jpg">
              <p>直播中心</p>
            </router-link>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        plateid:"",
        global
    };
  },
  props: {
    plates:Array
  },
  components: {},

  computed: {},

  mounted() {
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="名师简介"){
            this.plateid = this.plates[i]._id;
        }
    }
  },
  methods: {}
}

</script>
<style  lang="scss" scoped>
  @import "@/assets/css/style_Phone.scss";
</style>
